import apiUseCases from "@src/cloud-connect/api";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";
import {
  FilenameObjectType,
  FilenameUsableResult,
} from "@src/types/ota-update";

export const isFilenameUsableUseCase = async (
  filename: string,
  objectType: FilenameObjectType,
): Promise<FilenameUsableResult> => {
  try {
    const namespace = store.getState().yourSlice.authContext.customerNamespace;

    const response = await apiUseCases.isFilenameUsable(
      namespace,
      filename,
      objectType,
    );

    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      error: parseAxiosApiError(error, "Failed to check filename usability")
        .message,
    };
  }
};
